/**
 * Подготавливает объект для отправки:
 * - включает все заполненные поля, даже если они не изменились
 * - если значение было и стало '', undefined или null — исключает
 * - если значение было и стало пустым — исключает
 * - если было значение → стало пусто — записывает null
 * - если значение появилось — включает новое значение
 *
 * @param {Object} original - Исходный объект (например, из базы данных)
 * @param {Object} updated - Новый объект с изменениями (например, из формы)
 * @returns {Object} Объект, содержащий финальные данные для отправки на сервер
 *
 * @example
 * const original = { name: "Alex", age: 30 };
 * const updated = { name: "", age: 31 };
 *
 * prepareObjectForSubmit(original, updated);
 * Вернёт: { name: null, age: 31 }
 */
export function prepareObjectForSubmit(original = {}, updated = {}) {
  const result = {};

  // Перебираем все ключи, которые есть в объекте обновлённых данных
  for (const key in updated) {
    if (!Object.prototype.hasOwnProperty.call(updated, key)) continue; // Пропускаем унаследованные свойства

    const originalVal = original[key]; // Значение в оригинале (например, из БД)
    const updatedVal = updated[key]; // Значение в обновлённом объекте (например, из формы)

    // Определяем, было ли оригинальное значение "пустым"
    const isOriginalEmpty = originalVal === '' || originalVal === undefined || originalVal === null;
    // Определяем, является ли новое значение "пустым"
    const isUpdatedEmpty = updatedVal === '' || updatedVal === undefined || updatedVal === null;

    // ➔ Если было пусто и осталось пустым — это не изменение, поле можно пропустить
    if (isOriginalEmpty && isUpdatedEmpty) {
      continue;
    }

    // ➔ Если раньше было заполнено, а теперь стало пусто — нужно явно поставить null
    if (!isOriginalEmpty && isUpdatedEmpty) {
      result[key] = null;
    }
    // ➔ В остальных случаях (значение появилось или изменилось) — просто сохраняем новое значение
    else {
      result[key] = updatedVal;
    }
  }

  // Возвращаем итоговый объект с изменениями
  return result;
}
